export const common = {
  perMonth: '/month',
  perYear: '/year',
  buyNow: 'Buy Now',
  viewMore: 'View More',
  getQuote: 'Get a Quote'
};